import * as React from "react";
import classnames from "classnames";
import { Text, Toggle } from "@grandvisionhq/elements";
import { Icon } from "@grandvisionhq/icons";
/* empty css                   */
const ToggleInfoBox = ({
  toggleId,
  icon,
  text,
  accessibleLabelText,
  className,
  checked,
  onChange,
  ...rest
}) => /* @__PURE__ */ React.createElement("div", { ...rest, className: classnames("toggle-info-box", className) }, /* @__PURE__ */ React.createElement(Icon, { className: "toggle-info-box__icon", name: icon }), /* @__PURE__ */ React.createElement(Text, { variant: "caption", component: "span", "aria-hidden": true, className: "toggle-info-box__text" }, text), /* @__PURE__ */ React.createElement("label", { className: "toggle-info-box__label", htmlFor: toggleId }, accessibleLabelText && /* @__PURE__ */ React.createElement("span", { className: "toggle-info-box__accessibleLabel--visually-hidden" }, accessibleLabelText), /* @__PURE__ */ React.createElement(
  Toggle,
  {
    className: "toggle-info-box__toggle",
    id: toggleId,
    checked,
    onChange
  }
)));
export {
  ToggleInfoBox as default
};
//# sourceMappingURL=ToggleInfoBox.js.map
